<template>
    <div class="callout callout-danger overlay-wrapper" style="position: relative;">
        <div class="overlay" v-if="isGuardando == true"><i class="fas fa-3x fa-sync-alt fa-spin"></i>
            <div class="text-bold pt-2">{{$t('general.guardando')}}...</div>
        </div>
        <div :title="this.mensajenoeliminable" v-if="iseliminable==false" class="ribbon ribbon-top-left"><span>No
                eliminable</span>
        </div>
        <div class="row">
            <div class="col" style="min-width:200px;">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <button type="button" :style="estiloreducido" :disabled="bloqueos && bloqueos.id_baremo != 0"
                            @click="mostrarBaremo = !mostrarBaremo" class="btn btn-default">
                            <i class="fas fa-list"></i>
                        </button>
                    </div>
                    <presupuestobaremo :servicio="servicio" :visible="mostrarBaremo" :trabajodatos="work" :id="id"
                        @actualizarconcepto="actualizarconcepto" @update:visible="mostrarBaremo=false" />
                    <v-select ref="desplegable" v-if="especialidadesb" class="vsel" v-model="desplegable" :options="especialidadesb"
                        @change="toggleSelect = !toggleSelect" v-show="toggleSelect" />
                    <input ref="codigo" :style="estiloreducido" readonly type="text" @input="autosave=true"
                        class="form-control input-xs" v-model="work.codigo" placeholder="Código">
                </div>
                <div class="form-group" v-if="mostrar && mostrar.nombre != 0">
                    <textarea ref="nombre" style="resize:vertical;font-size:12px;display: block;" :readonly="bloqueos &&bloqueos.nombre != 0" @input="autosave=true"
                        class="form-control input-xs" v-model="work.nombre" placeholder="Concepto" cols="10"></textarea>
                </div>
                <span v-if="trabajo.datos.parametros_envio && trabajo.datos.parametros_envio!='' && trabajo.datos.parametros_envio.id_presuval && trabajo.datos.parametros_envio.version" class="badge bg-primary" title="Valoración AXA a la que pertenece">{{trabajo.datos.parametros_envio.id_presuval}}-{{ trabajo.datos.parametros_envio.version }}</span>
            </div>
            <div class="col" style="min-width:200px;">
                <div class="form-group" v-if="mostrar && mostrar.descripcion_factura != 0">
                    <textarea ref="descripcion_factura" style="resize:vertical;font-size:12px;display: block;" @input="autosave = true" class="form-control input-xs"
                        :readonly="bloqueos && bloqueos.descripcion_factura != 0" v-model="work.descripcion_factura"
                        placeholder="Descripción" rows="4"></textarea>
                </div>
            </div>
            <div class="col">
                <div class="input-group " v-if="mostrar && mostrar.precio != 0">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text input-xs">{{ $t('general.precio')
                            }}</span>
                    </div>
                    <input ref="precio" :style="estiloreducido" :readonly="bloqueos && bloqueos.precio != 0" type="Number" @input="autosave = true; calculartotal()"
                        v-model="work.precio" class="form-control input-xs" placeholder="Precio">
                </div>
                <div class="input-group " v-if="mostrar && mostrar.precio_operario != 0">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text">{{ $t('general.precio') }} Op.</span>
                    </div>
                    <input ref="precio_operario" :style="estiloreducido" :readonly="bloqueos && bloqueos.precio_operario != 0" type="Number"
                        @input="autosave=true" v-model="work.precio_operario" class="form-control"
                        placeholder="Precio Operario">
                </div>
                <div class="input-group " v-if="mostrar && mostrar.cantidad != 0">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text">{{ $t('general.cantidad') }}</span>
                    </div>
                    <input ref="cantidad" :style="estiloreducido" :readonly="bloqueos && bloqueos.cantidad != 0" type="Number"
                        @input="autosave = true; calculartotal()" v-model="work.cantidad" class="form-control" placeholder="Cantidad">
                </div>
            </div>
            <div class="col" style="max-width: 170px" v-if="mostrar && mostrar.descuento != 0">
                <select ref="desc_incr" :style="estiloreducido" :disabled="bloqueos && bloqueos.desc_incr != 0" @input="autosave = true; "
                    v-if="mostrar && mostrar.desc_incr" v-model="work.desc_incr" class="form-control input-xs">
                    <option value="0">Descuento</option>
                    <option value="1">Incremento</option>
                </select>
                <div class="input-group" v-if="mostrar && mostrar.descuento_aplicado != 0">
                    <input ref="descuento" :style="estiloreducido" :disabled="bloqueos && bloqueos.descuento_aplicado != 0" @input="autosave = true; calculartotal()"
                        type="number" class="form-control" v-model="work.descuento">
                    <div class="input-group-append">
                        <span :style="estiloreducido" class="input-group-text"><i class="fas fa-percentage"></i></span>
                    </div>
                </div>
                <div class="input-group" v-if="mostrar && mostrar.descuento_importe != 0">
                    <!--<input :style="estiloreducido" :disabled="bloqueos.descuento_importe != 0" @input="autosave=true"
                        type="number" class="form-control" v-model="work.descuento_importe">-->
                    <input ref="descuento_importe" :style="estiloreducido" type="number" @input="autosave = true; calculartotal()"
                        v-model="work.descuento_importe" class="form-control"
                        :disabled="bloqueos && bloqueos.descuento_importe != 0">
                    <div class="input-group-append">
                        <span class="input-group-text" :style="estiloreducido"><i class="fas fa-euro-sign"></i></span>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="input-group" v-if="mostrar && mostrar.iva != 0">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text">{{ $t('general.impuesto') }}</span>
                    </div>
                    <select ref="iva_trabajo" :style="estiloreducido" :disabled="bloqueos && bloqueos.iva != 0" @input="autosave=true"
                        v-model="work.iva_trabajo" class="form-control input-xs">
                        <option v-for="impuesto in impuestos" :key="impuesto.id" :value="impuesto.valor_iva">{{
                            impuesto.valor_iva }}</option>
                    </select>
                </div>
                <div v-if="mostrar && mostrar.destinatario_factura" class="input-group" title="Destinatario">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text">Dest.</span>
                    </div>
                    <select ref="destinatario_presupuesto_trabajo" :style="estiloreducido" :disabled="bloqueos && bloqueos.destinatario_factura != 0"
                        @input="autosave=true" v-model="work.destinatario_presupuesto_trabajo"
                        class="form-control input-xs">
                        <option value="Compañia">{{ $t('general.compania') }}</option>
                        <option value="Cliente">{{ $t('general.asegurado') }}</option>
                    </select>
                </div>
                <div class="input-group" title="Daños" v-if="mostrar && mostrar.tipo_dano != 0">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text">{{ $t('general.danyos') }}</span>
                    </div>
                    <select ref="tipo_dano" :style="estiloreducido" :disabled="bloqueos && bloqueos.tipo_dano != 0" @input="autosave=true"
                        v-if="mostrar && mostrar.tipo_dano" v-model="work.tipo_dano" class="form-control input-xs">
                        <option value="esteticos">Estéticos</option>
                        <option value="directos">Directos</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="input-group" title="Total al cliente">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text bg-success">{{ $t('general.total') }}</span>
                    </div>
                    <input ref="preciototal" :style="estiloreducido" type="text" class="form-control" placeholder="Precio"
                        v-model="preciototal" readonly>
                    <div class="input-group-append">
                        <span class="input-group-text" :style="estiloreducido"><i class="fas fa-euro-sign"></i></span>
                    </div>
                </div>
                <div class="input-group" title="Total al operario">
                    <div class="input-group-prepend">
                        <span :style="estiloreducido" class="input-group-text bg-danger">{{ $t('general.total') }}</span>
                    </div>
                    <input ref="precio_operario" :style="estiloreducido" type="text" class="form-control" v-model="work.precio_operario"
                        placeholder="Precio Operario" readonly>
                    <div class="input-group-append">
                        <span class="input-group-text" :style="estiloreducido"><i class="fas fa-euro-sign"></i></span>
                    </div>
                </div>
            </div>

            <div class="col" style="max-width: 150px">
                <div class="custom-control custom-switch custom-switch-on-success">
                    <input ref="aprobar_trabajo" :disabled="iseliminable==false" v-model="aprobar_trabajo" type="checkbox"
                        class="custom-control-input" @change="marcarAprobado()"
                        :id="'aprobado_' + $props.trabajo.datos.idtrabajo_presupuesto">
                    <label class="custom-control-label"
                        :for="'aprobado_' + $props.trabajo.datos.idtrabajo_presupuesto">{{ $t('general.aprobado')
                        }}</label>
                </div>
                <div class="custom-control custom-switch custom-switch-on-indigo">
                    <input ref="estado_trabajo" :disabled="iseliminable==false" v-model="estado_trabajo" type="checkbox"
                        class="custom-control-input" @change="marcarEstado()"
                        :id="'estado_' + $props.trabajo.datos.idtrabajo_presupuesto">
                    <label class="custom-control-label" :for="'estado_' + $props.trabajo.datos.idtrabajo_presupuesto">{{
                        $t('general.subsanado') }}</label>
                </div>
                <div class="custom-control custom-switch">
                    <input ref="facturar_trabajo" v-model="facturar_trabajo" type="checkbox" class="custom-control-input"
                        @change="marcarfacturar()" :id="'facturar_' + $props.trabajo.datos.idtrabajo_presupuesto">
                    <label class="custom-control-label"
                        :for="'facturar_' + $props.trabajo.datos.idtrabajo_presupuesto">{{ $t('general.facturar')
                        }}</label>
                </div>
            </div>
            <div class="col" style="max-width:105px;min-width:105px">
                <div class="btn-group d-flex justify-content-end">
                    <button :disabled="iseliminable==false" @input="autosave=false" @click="guardardatos()"
                        class="btn btn-primary"><i class="fas fa-save"></i></button>
                    <button :disabled="iseliminable==false" @input="autosave=false" @click="eliminar()"
                        class="btn btn-danger"><i class="fas fa-times"></i></button>
                </div>
                <div class="input-group " v-if="mostrar && mostrar.orden != 0">
                    <input ref="orden_presupuesto_trabajo" title="Orden en factura (menor número mayor prioridad)" :disabled="iseliminable==false"
                        type="Number" @input="autosave=true" v-model="work.orden_presupuesto_trabajo"
                        class="form-control" placeholder="Orden" style="max-width: 90px">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import presupuestobaremo from './presupuesto_baremo.vue';
import debounce from 'debounce';
import { PwgsApi } from '../../../../../../services/PwgsApi';
export default ({
    props: ['trabajo','seleccionado','id', 'servicio'],
    setup() {
        return;
    },
    components: {
        presupuestobaremo,
    },
    data() {
        return {
            mostrarBaremo:false,
            autosave: false,
            work: this.trabajo.datos,
            mostrar: [],
            bloqueos: [],
            toggleSelect: false,
            idtrabajos: '',
            especialidadesa: [],
            especialidadesb: [],
            especialidadesbid: [],
            desplegable: [],
            iseliminable:true,
            mensajenoeliminable:'',
            miid: '',
            trabajoseleccionado: [],
            renderComponent: true,
            facturar_trabajo: false,
            estado_trabajo: false,
            aprobar_trabajo: false,
            isGuardando:false,
            guardadoAutomatico: null,  // Almacenará la función de debounce para guardardatos
            isGuardadoAutomaticoPendiente: false, // Variable que indica si hay un autoguardado pendiente
            impuestos: [],
            estiloreducido:'height:30px;font-size:12px;text-align:right;',
            preciototal:0,

        }
    },
    computed: {
        
      
    },
    methods: {
        cambiarIva(value){
            if(!this.bloqueos.iva != 0){
                this.work.iva_trabajo = value;
            }
            this.guardardatos();
        },
        cambiarDest(value){
            if(!this.bloqueos.destinatario_factura != 0){
                this.work.destinatario_presupuesto_trabajo = value;
            }
            this.guardardatos();
        },
        cargardatos() {
            const activo = document.activeElement;
            let campoActivo = null;

            if (this.$refs) {
                Object.keys(this.$refs).forEach(key => {
                    if (this.$refs[key] === activo) {
                        campoActivo = key;
                    }
                });
            }
            if (!this.work || Object.keys(this.work).length === 0) {
                this.work = { ...this.$props.trabajo.datos };
            } else {
                const nuevosDatos = this.$props.trabajo.datos;
                for (let key in nuevosDatos) {
                    if (key !== campoActivo) {
                        this.work[key] = nuevosDatos[key];
                    }
                }
            }
            this.mostrar = this.$props.trabajo.opciones.mostrar;
            this.bloqueos = this.$props.trabajo.opciones.bloqueos;
            //console.log("bloqueos", this.bloqueos);
            if (this.$props.trabajo.opciones.eliminable){
                var eliminable = this.$props.trabajo.opciones.eliminable.estado;
                if (eliminable != '1') {
                    this.iseliminable = false;
                    this.mensajenoeliminable = this.$props.trabajo.opciones.eliminable.mensaje;
                }
            }
            if(this.work.incluir_trabajo == 1){ this.facturar_trabajo = true; }
            if(this.work.estado_trabajo_presupuesto == "Subsanado"){ this.estado_trabajo = true; }
            if(this.work.aprobado_presupuesto_trabajo == "SI"){ this.aprobar_trabajo = true; }
            this.calculartotal();
        },
        calculartotal() {
            // Calcula el subtotal
            let subtotal = this.work.precio * this.work.cantidad;
            // Si el descuento es en importe, calcula el porcentaje de descuento
            if (this.work.descuento_importe != 0) {
                this.work.descuento = (this.work.descuento_importe / subtotal) * 100;
                this.work.descuento = Math.round(this.work.descuento * 100) / 100; // Redondeo a 2 decimales
            }
            if (this.work.descuento > 999.9999) {
                if (this.work.descuento > 1000.0001) {
                    this.$toast.add({ severity: 'warn', summary: "Aviso", detail: "Corregido importe de descuento, no puede ser superior a 999.9999%", life: 10000 });
                }
                this.work.descuento = 999.9999;
                this.work.descuento_importe = subtotal * (999.9999 / 100);
                this.work.descuento_importe = Math.round(this.work.descuento_importe * 100) / 100;
            }
            // Si el descuento es en porcentaje, calcula el precio total con descuento
            if (this.work.descuento != 0) {
                let descuento = subtotal * (this.work.descuento / 100);
                //console.log("descuento", descuento);

                if (this.work.desc_incr != 0) {
                    this.preciototal = subtotal + descuento;
                } else {
                    this.preciototal = subtotal - descuento;
                }
            } else {
                this.preciototal = subtotal; // Sin descuento, el precio total es el subtotal
            }

            // Redondea el precio total a 2 decimales
            this.preciototal = Math.round(this.preciototal * 100) / 100;
        },
        autoguardado() {
            if (this.autosave) {
                this.isGuardadoAutomaticoPendiente = true; // Marcar el autoguardado pendiente inmediatamente
                this.guardadoAutomatico();
                this.autosave = false; // Resetear autosave después de guardar
            }
        },
        // Cancelar autoguardado pendiente
        cancelarAutoguardado() {
            if (this.guardadoAutomatico) {
                this.guardadoAutomatico.clear(); // Cancela cualquier autoguardado pendiente
                this.autosave = false;
                this.isGuardadoAutomaticoPendiente = false; //
            }
        },
        async guardardatos(recargar = true) {
            //PUT  modulos/pwgsapi/index.php/presupuestos/:id_trabajo/modificar-trabajo
            if (recargar == true) {
                this.isGuardando = true; // Activar el estado de guardando
            }
            //Cancelamos guardados pendientes si le damos desde el botón también.
            if (this.isAutoguardadoPendiente()) {
                this.cancelarAutoguardado();
            }
            const api = new PwgsApi;
            //console.log('work', this.work);
            let subidadatos;
            try {
                subidadatos = {
                    codigo:this.work.codigo, 
                    id_baremo: this.work.id_baremo, 
                    nombre: this.work.nombre, 
                    descripcion_factura: this.work.descripcion_factura, 
                    precio: this.work.precio, 
                    precio_operario: this.work.precio_operario, 
                    descuento: this.work.descuento, 
                    descuento_importe: this.work.descuento_importe, 
                    descuento_aplicado: this.work.descuento_aplicado, 
                    cantidad: this.work.cantidad, 
                    aprobado: this.work.aprobado_presupuesto_trabajo, 
                    estado: this.work.estado_trabajo_presupuesto, 
                    destinatario_factura: this.work.destinatario_presupuesto_trabajo, 
                    tipo_dano: this.work.tipo_dano, 
                    //orden: this.work.orden, 
                    facturar: this.work.incluir_trabajo, 
                    desc_incr: this.work.desc_incr, 
                    tipo_trabajo: this.work.tipo_trabajo, 
                    ancho_cristal: this.work.ancho_cristal, 
                    alto_cristal: this.work.alto_cristal, 
                    metro_lineal: this.work.metro_lineal,
                    iva:  this.work.iva_trabajo,
                    orden: this.work.orden_presupuesto_trabajo
                }
                //console.log('bloqueos', this.bloqueos);
                Object.keys(this.bloqueos).forEach(key => {
                    if (this.bloqueos[key] === "1" && key in subidadatos) {
                        delete subidadatos[key];
                    }
                });
                //console.log('subidadatos', subidadatos);
                await api.put('presupuestos/' + this.$props.trabajo.datos.idtrabajo_presupuesto + '/modificar-trabajo', subidadatos);
                if (recargar === true) {
                    this.$parent.cargartrabajospresupuesto();
                }
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: "Error al guardar el trabajo", detail: error, life: 5000 });
                this.isGuardadoAutomaticoPendiente = false; 
                if (recargar) {
                    this.$parent.$parent.togglerecargar();
                }
            } finally {
                if (recargar == true) {
                    this.isGuardando = false; // Activar el estado de guardando
                }
            }
        },
        isAutoguardadoPendiente() {
            return this.isGuardadoAutomaticoPendiente;
        },
        async eliminar() { 
            if(window.confirm('¿Quiere eliminar el trabajo del presupuesto?')){
                //DELETE  modulos/pwgsapi/index.php/presupuestos/:id_trabajo/eliminar-trabajo
                const api = new PwgsApi;
                try {
                    await api.delete('presupuestos/' + this.$props.trabajo.datos.idtrabajo_presupuesto + '/eliminar-trabajo');
                    this.$toast.add({ severity: 'success', summary: 'Eliminado', detail: 'El trabajo fue eliminado correctamente', life: 1000 });
                    this.$parent.cargartrabajos();
                    this.$parent.cargartrabajospresupuesto();
                    this.cargardatos();
                } catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error al eliminar', detail: error, life: 5000 });
                    
                }
            }
        },
        async listartrabajos(){
                // POST  modulos/pwgsapi/index.php/servicios/id_servicio/baremo
            const api = new PwgsApi;
            let subidadatos = { id_especialidad: this.$props.trabajo.datos.especialidades_idespecialidad };
            this.especialidadesa = await api.post('servicios/' + this.$props.id + '/baremo', subidadatos);
                for (let i = 0; i < this.especialidadesa.length; i++) {
                    this.especialidadesb.push(this.especialidadesa[i].nombre);
                    this.especialidadesbid.push(this.especialidadesa[i].idtrabajo);
                }
        },
        async actualizarconcepto(id){
            this.$emit('actualizarconcepto', id);
        },
        async cambiartrabajo() {
            //GET  modulos/pwgsapi/index.php/trabajos/:id_trabajo
            for (let i = 0; i < this.especialidadesb.length; i++){
                if (this.especialidadesb[i] == this.desplegable) {
                    this.trabajoseleccionado = this.especialidadesa[i];
                    this.trabajoseleccionado.id_baremo = this.especialidadesbid[i];
                    //console.log('seleccionado', this.trabajoseleccionado.id_baremo);
                    //PUT  modulos/pwgsapi/index.php/presupuestos/:id_trabajo/modificar-trabajo
                    const api = new PwgsApi;
                    let subidadatos;
                    //console.log('seleccionado', this.trabajoseleccionado, this.desplegable);
                    try {
                        subidadatos = { codigo: this.trabajoseleccionado.codigo, id_baremo: this.trabajoseleccionado.id_baremo, nombre: this.trabajoseleccionado.nombre,precio: this.trabajoseleccionado.precio, precio_operario: this.trabajoseleccionado.precio_operario, cantidad: this.trabajoseleccionado.cantidad,destinatario: this.trabajoseleccionado.destinatario}
                        await api.put('presupuestos/' + this.$props.trabajo.datos.idtrabajo_presupuesto + '/modificar-trabajo', subidadatos);
                        this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    }
                    catch (error) {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El trabajo no se puede modificar ya que está incluido en otro presupuesto generado', life: 5000 });
                    }
                }
            }
            this.$parent.$parent.$parent.cargardatos(this.$props.id);  
        },
        marcarfacturar (){
            if (this.facturar_trabajo==true) { 
                this.work.incluir_trabajo = 1; 
            }else{
                this.work.incluir_trabajo = 0; 
            }
            this.guardardatos();
        },
        marcarEstado (){
            if (this.estado_trabajo==true) { 
                this.work.estado_trabajo_presupuesto = 'Subsanado'; 
            }else{
                this.work.estado_trabajo_presupuesto = ''; 
            }
            this.guardardatos();
        },
        marcarAprobado (){
            if (this.aprobar_trabajo==true) { 
                this.work.aprobado_presupuesto_trabajo = 'SI'; 
            }else{
                this.work.aprobado_presupuesto_trabajo = ''; 
            }
            this.guardardatos();
        },
        async cargarImpuestos(){
            const api = new PwgsApi();
            const ress = await api.get('impuestos');
            this.impuestos = ress.datos;
        },

 
    },
    mounted() {
        this.cargardatos();
        this.listartrabajos();
        this.cargarImpuestos();
    },
    created() {
        // Creación de la función de debounce con un retraso de 5000 ms
        this.guardadoAutomatico = debounce(() => {
            // Crear una función async para manejar el guardado
            const guardar = async () => {
                await this.guardardatos(false); // Guardar los datos
            };
            guardar(); // Ejecutar la función async
        }, 2000); // 5 segundos de espera tras el último cambio antes de guardar
    },
    watch: {
        
        trabajo(){
            this.cargardatos();
        },
        seleccionado() {
            this.cargardatos();
        },
        desplegable() { 
            this.cambiartrabajo(); 
        },
        autosave(val) {
            if (val === true) {
                this.autoguardado(); // Ejecuta el guardado cuando autosave es true
            }
        }
    }
})
</script>
<style scoped>
.ribbon {
  width: 100px;
  height: 100px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #2980b9;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 175px;
  padding: 5px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 10px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
  z-index: 20;
}
/* top left*/
.ribbon-top-left {
  top: -4px;
  left: -8px;
}
.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}
.ribbon-top-left::before {
  top: 0;
  right: 0;
}
.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}
.ribbon-top-left span {
  right: -20px;
  top: 25px;
  transform: rotate(-45deg);
}
/* top right*/
.ribbon-top-right {
  top: -10px;
  right: -10px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}
/* bottom left*/
.ribbon-bottom-left {
  bottom: -10px;
  left: -10px;
}
.ribbon-bottom-left::before,
.ribbon-bottom-left::after {
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.ribbon-bottom-left::before {
  bottom: 0;
  right: 0;
}
.ribbon-bottom-left::after {
  top: 0;
  left: 0;
}
.ribbon-bottom-left span {
  right: -25px;
  bottom: 30px;
  transform: rotate(225deg);
}
.vs__dropdown-menu{
    width:30em !important;
}
/* bottom right*/
.ribbon-bottom-right {
  bottom: -10px;
  right: -10px;
}
.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}
.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}
.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}
.ribbon-bottom-right span {
  left: -25px;
  bottom: 30px;
  transform: rotate(-225deg);
}
.vsel ::v-deep(.vs__dropdown-menu) {
    width: auto !important;
}
</style>